import { db } from './db';

export const save = (function () {
  const fx = {};
  const timeouts = {};

  fx.local = ({ tournament } = {}) => {
    if (!tournament?.tournamentId) return;
    clearTimeout(timeouts[tournament.tournamentId]);
    timeouts[tournament.tournamentId] = setTimeout(() => syncSave(tournament), 500);
  };

  function syncSave(tournament) {
    if (tournament?.tournamentId) {
      db.addTournament(tournament);
      const tournamentRecordString = localStorage.getItem('tournamentRecord');
      if (tournamentRecordString) {
        try {
          const tournamentRecord = JSON.parse(tournamentRecordString);
          if (tournamentRecord?.tournamentId === tournament.tournamentId) {
            localStorage.removeItem('tournamentRecord');
          }
        } catch (err) {
          console.log('invalid tournamentRecord', { err });
        }
      }
    } else {
      console.log('invalid tournament', { tournament });
    }
  }

  return fx;
})();
